import { toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "form-section-inner" }
const _hoisted_4 = {
  class: "accordion",
  role: "tablist"
}
const _hoisted_5 = { class: "forms-wrap" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { id: "adjust-div" }, null, -1)
const _hoisted_7 = { class: "form-box-inner" }
const _hoisted_8 = { class: "form-inputs" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-times",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-times",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_12 = { class: "form-options" }
const _hoisted_13 = { class: "fo-left" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_16 = { class: "fo-left advanced-search-rt-area" }
const _hoisted_17 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z" })
], -1)
const _hoisted_18 = { class: "advanced-search-section" }
const _hoisted_19 = { class: "container advanced-search-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_person_advance_search = _resolveComponent("person-advance-search")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_company_advance_search = _resolveComponent("company-advance-search")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("section", {
      class: ["form-section", _ctx.isCompactForm() ? 'compact' : '']
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: _ctx.isCompactForm() ? 'col-xl-10' : 'col-xl-8'
          }, [
            _createVNode("div", _hoisted_3, [
              _withDirectives(_createVNode("h1", { class: "form-title" }, _toDisplayString(_ctx.$t("default.search_form.welcome")), 513), [
                [_vShow, !_ctx.isCompactForm()]
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode("form", {
                    class: "form-box form-one",
                    onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", {
                          class: ["form_cover single_form_cover", { error: _ctx.canShowFormError('name') && !_ctx.basicSearchForm.name.length && !_ctx.basicSearchForm.address.length }]
                        }, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.basicSearchForm.name = $event)),
                            placeholder: _ctx.getPlaceholderForName(),
                            autofocus: "",
                            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onBasicSearch()), ["enter"]))
                          }, null, 40, ["placeholder"]), [
                            [_vModelText, _ctx.basicSearchForm.name]
                          ]),
                          _withDirectives(_createVNode("span", {
                            class: "clear_content",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetField('name')))
                          }, [
                            _hoisted_9
                          ], 512), [
                            [_vShow, _ctx.basicSearchForm.name.length]
                          ])
                        ], 2),
                        _createVNode("div", {
                          class: ["form_cover single_form_cover", { error: _ctx.canShowFormError('address') && !_ctx.basicSearchForm.name.length && !_ctx.basicSearchForm.address.length }]
                        }, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.basicSearchForm.address = $event)),
                            placeholder: _ctx.getPlaceholderForPlace(),
                            autofocus: "",
                            onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.onBasicSearch()), ["enter"]))
                          }, null, 40, ["placeholder"]), [
                            [_vModelText, _ctx.basicSearchForm.address]
                          ]),
                          _withDirectives(_createVNode("span", {
                            class: "clear_content",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetField('address')))
                          }, [
                            _hoisted_10
                          ], 512), [
                            [_vShow, _ctx.basicSearchForm.address.length]
                          ])
                        ], 2)
                      ]),
                      _createVNode("button", {
                        type: "button",
                        "data-toggle": "tooltip",
                        title: _ctx.$t('default.search_form.search'),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onBasicSearch()))
                      }, [
                        _hoisted_11
                      ], 8, ["title"])
                    ])
                  ], 32)
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("p", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSearchToggle(_ctx.Config.CONSTANTS.PERSON))),
                      class: ["option-one", {
                        'active-option': _ctx.searchType.person,
                      }]
                    }, [
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(_ctx.$t("default.search_form.person")), 1)
                    ], 2),
                    _createVNode("p", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSearchToggle(_ctx.Config.CONSTANTS.COMPANY))),
                      class: ["option-two", _ctx.searchType.company ? 'active-option' : '']
                    }, [
                      _hoisted_15,
                      _createTextVNode(_toDisplayString(_ctx.$t("default.search_form.company")), 1)
                    ], 2)
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_16, [
                    _createVNode("p", {
                      class: ["advanced-search-activation", { active: _ctx.openAdvanceSearch }],
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleAdvanceSearchPopup()))
                    }, [
                      _createVNode("span", {
                        "data-toggle": "tooltip",
                        title: _ctx.$t('default.button.advanced_search')
                      }, [
                        _hoisted_17
                      ], 8, ["title"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("default.button.advanced_search")), 1)
                    ], 2)
                  ], 512), [
                    [_vShow, !_ctx.isCompactForm()]
                  ])
                ])
              ])
            ])
          ], 2)
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode(_component_el_drawer, {
            modelValue: _ctx.openAdvanceSearch,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.openAdvanceSearch = $event)),
            direction: "ttb",
            size: "200",
            "show-close": true
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_el_tabs, {
                  type: "card",
                  modelValue: _ctx.activeTab,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.activeTab = $event))
                }, {
                  default: _withCtx(() => [
                    (_ctx.searchType.person)
                      ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                          key: 0,
                          label: _ctx.$t('default.label.person_result'),
                          name: _ctx.Config.CONSTANTS.PERSON
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_person_advance_search, { page: "home" })
                          ]),
                          _: 1
                        }, 8, ["label", "name"]))
                      : _createCommentVNode("", true),
                    (_ctx.searchType.company)
                      ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                          key: 1,
                          label: _ctx.$t('default.label.company_result'),
                          name: _ctx.Config.CONSTANTS.COMPANY
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_company_advance_search, { page: "home" })
                          ]),
                          _: 1
                        }, 8, ["label", "name"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ], 2)
  ]))
}